import ConfigurationHistoryTable from "../../components/history-table/configuration-history-table.component";
import {
  getDaylightProfileHistory,
  getDaylightProfileHistoryDetail,
} from "src/core/api/services/asset/light-profile/daylight-profile.service";

type DaylightProfileHistoryProps = {
  assetCode: string | null;
  isOpen: boolean;
  handleClose: () => void;
  data?: any[];
  isLoading?: boolean;
  refetchTrigger?: number;
};

export function DaylightProfileHistory({
  assetCode,
  isOpen,
  handleClose,
  data,
  isLoading,
  refetchTrigger,
}: DaylightProfileHistoryProps) {
  return (
    <ConfigurationHistoryTable
      isOpen={isOpen}
      handleClose={handleClose}
      assetCode={assetCode}
      title="Daylight Profile History"
      subtitle="Last 13 months"
      retainedText="Retained for 13 Months"
      actionColumnTitle="Profile Action"
      actionTitleField="title"
      issueTimeField="sentOn"
      acknowledgeTimeField="ackTime"
      defaultSortBy="SentOn"
      queryKey="getDaylightProfileHistory"
      getHistory={getDaylightProfileHistory}
      getHistoryDetail={getDaylightProfileHistoryDetail}
      fallbackData={data}
      fallbackIsLoading={isLoading}
      refetchTrigger={refetchTrigger}
    />
  );
}
